<template>
    <div class="container-fluid">
        <div class="alert alert-danger" v-if="$store.state.user && !$store.state.user.subdomain">
            サブドメイン未登録の場合、ピックアップは設定できません。
        </div>
        <div class="row no-gutters d-flex justify-content-center">
            <div class="slider">
                <div class="slider-item" v-for="p in pickups" :key="p.id">
                    <pickup :novel="p" @removePickup="removePickup"></pickup>
                </div>
                <div class="slider-item" v-if="pickups.length < 3">
                    <div class="my-0 add-pickup b-light pointer" @click="showPickupModal()">
                        <div>
                            <i class="fas fa-plus-circle big-icon"></i>
                            <div class="my-2">ピックアップ追加</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <pickup-modal :books="books" @saved="load()"></pickup-modal>
    </div>
</template>

<style scoped lang="scss">
.pickup-caption {
    padding: .3rem;
    margin: .5rem 0;
    font-size: 1.1rem;
    text-align: center;
}
.big-icon {
    font-size: 5rem;
}
.slider {
    display: flex;
    overflow: scroll;
    margin: 0 15px;
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
        display:none;
    }
    .slider-item {
        padding: 5px 15px;
        .add-pickup {
            width: 213px;
            height: 213px;
            padding-top: 3rem;
            text-align: center;
            border-radius: .5rem;
        }
    }
}
</style>

<script>
import pickupModal from "./pickup";
import pickup from "components/Pickup";
export default {
    components: {
        pickupModal,
        pickup,
    },
    data() {
        return {
            books: {},
            pickups: [],
            show: false,
        }
    },
    methods: {
        load() {
            axios.get("/mypage/books/get?all=1").then(res => {
                this.books = res.data;
                this.pickups = [];
                for (const key in this.books) {
                    const genre = this.books[key];
                    for (const b of genre) {
                        if (b.pickup_number) {
                            this.pickups.push(b);
                        }
                    }
                }
                this.pickups = _.orderBy(this.pickups, ["pickup_number"]);
            }).catch(err => {
                alert.err(err);
            }).finally(() => {
                this.show = true;
            });
        },
        showPickupModal() {
            if (this.$store.state.user.subdomain) {
                $("#pickup-modal").modal();
            } else {
                alert.warn("サブドメインを登録してください。");
            }
        },
        removePickup(b) {
            axios.post("/mypage/books/pickup/remove", {id: b.id}).then(res => {
                this.load();
            });
        },
    },
    mounted() {
        this.load();
    }
}
</script>